import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import MyCustomToast from "pages/Toast/MyCustomToast";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import App from "./App";
import { msalConfig } from "./auth/authConfig";
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import store from "./store";

const msalInstance = new PublicClientApplication(msalConfig);
const app = (
  <ToastProvider components={{ Toast: MyCustomToast }} placement="top-right">
    <Provider store={store}>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </BrowserRouter>
    </Provider>
  </ToastProvider>
);

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
